import { render, staticRenderFns } from "./ProcedureShow.vue?vue&type=template&id=a2485fd4&"
import script from "./ProcedureShow.vue?vue&type=script&lang=js&"
export * from "./ProcedureShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports